import { FiArchive } from 'react-icons/fi';
import type { NavItem } from '@/app/config/navigation';

/**
 * Inventory module manifest.
 *
 * `inventory.stock.read` is the tenant permission M18 requires for both the
 * balance read and the movement read (register §5: owner, staff AND viewer).
 * The capability gate is the tenant's retail plan entitlement.
 */
export const INVENTORY_STOCK_READ_PERMISSION = 'inventory.stock.read';

export const MANIFEST = {
  id: 'inventory',
  routes: [
    { path: '/inventory/stock', permission: INVENTORY_STOCK_READ_PERMISSION },
    { path: '/inventory/stock/:itemId', permission: INVENTORY_STOCK_READ_PERMISSION },
  ],
} as const;

export const NAV_ITEMS: ReadonlyArray<NavItem> = [
  {
    id: 'inventory.stock',
    to: '/inventory/stock',
    label: 'Stock',
    group: 'Inventory',
    order: 35,
    capability: 'retail_basic',
    permission: { require: [INVENTORY_STOCK_READ_PERMISSION] },
    icon: FiArchive.name,
  },
];
